// Configuration borrowed from oneidportal
export const REACT_APP_CLIENT_ID = (window as any).REACT_APP_CLIENT_ID || import.meta.env.VITE_CLIENT_ID || 'your-client-id';
export const REACT_APP_ISSUER = (window as any).REACT_APP_ISSUER || import.meta.env.VITE_ISSUER || 'https://your-okta-domain.com/oauth2/default';
export const REACT_APP_REDIRECT_URI = `${window.location.origin}/login/callback`;
export const REACT_APP_OKTA_TESTING_DISABLEHTTPSCHECK = import.meta.env.VITE_OKTA_TESTING_DISABLEHTTPSCHECK || false;

export const ORIGINAL_CLIENT_REDIRECT_URL = (window as any).VITE_ORIGINAL_CLIENT_REDIRECT_URL || import.meta.env.VITE_ORIGINAL_CLIENT_REDIRECT_URL;
export const NATIVE_APP_REDIRECT_URI = (window as any).VITE_NATIVE_APP_REDIRECT_URI || import.meta.env.VITE_NATIVE_APP_REDIRECT_URI;
export const FORGOT_PASSWORD_URL = (window as any).VITE_FORGOT_PASSWORD_URL || import.meta.env.VITE_FORGOT_PASSWORD_URL;
export const REGISTER_URL = (window as any).VITE_REGISTER_URL || import.meta.env.VITE_REGISTER_URL;
export const API_BASE_URL = (window as any).VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL;

export const config = {
  oidc: {
    clientId: REACT_APP_CLIENT_ID,
    issuer: REACT_APP_ISSUER,
    redirectUri: REACT_APP_REDIRECT_URI,
    scopes: ['openid', 'profile', 'email', 'address', 'phone', 'filteredgroups', 'groups', 'heightenedDomainID'],
    pkce: true,
    disableHttpsCheck: REACT_APP_OKTA_TESTING_DISABLEHTTPSCHECK,
  },
};
